export default __webpack_public_path__ + "static/media/testeira.cb8fb475.png";